<template>
  <div>
    <div class="flex mb-20px mr-10px">
      <el-input
        size="small"
        class="mr-10px !w-50"
        placeholder="请输入关键字"
        v-model="searchData.keywords"
        clearable
      ></el-input>
      <el-select
        v-model="searchData.organizationLevel"
        size="small"
        class="mr-10px !w-50"
        placeholder="请选择组织级别"
        clearable
      >
        <el-option
          v-for="item in controlHierarchyList"
          :key="item.value"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="searchList">搜索</el-button>
      <el-button size="small" @click="resetText">重置</el-button>
      <!-- :disabled="!$hasAccess('create')" -->
      <el-button
        type="primary"
        size="small"
        @click="handleEvent(null, 'updataAll')"
        :disabled="!['update', 'create'].includes(formProps.editType)"
      >
        批量修改排查人
      </el-button>
    </div>
    <el-table
      ref="table"
      :data="tableData"
      border
      class="w-full"
      :height="tableHeight"
      stripe
      v-loading="tableLoading"
      @selection-change="handleSelection"
    >
      <el-table-column
        v-if="['update', 'create'].includes(formProps.editType)"
        type="selection"
        width="50"
      ></el-table-column>
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column
        label="基础管理排查项目"
        prop="screeningItemsName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="组织级别" prop="organizationLevel" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ controlHierarchyListMap(scope.row.organizationLevel) }}
        </template>
      </el-table-column>
      <el-table-column
        label="排查标准"
        prop="screeningCriteria"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="隐患排查内容"
        prop="screeningContent"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="排查人" prop="deadlinePersonId" show-overflow-tooltip width="200">
        <template slot="header">
          <span class="text-red-500">*</span>
          排查人
        </template>
        <template slot-scope="scope">
          <MultiplePersonSelect
            :disabled="!['update', 'create'].includes(formProps.editType)"
            class="!w-full"
            v-model="scope.row.deadlinePersonId"
          ></MultiplePersonSelect>
        </template>
      </el-table-column>
      <template v-if="formProps.editType === 'completionStatus'">
        <el-table-column
          label="排查任务完成时间"
          prop="taskCompletionTime"
          show-overflow-tooltip
          width="200"
        >
          <template slot-scope="scope">
            {{
              scope.row.taskCompletionTime &&
                dayjs(scope.row.taskCompletionTime).format('YYYY-MM-DD HH:mm:ss')
            }}
          </template>
        </el-table-column>
        <el-table-column label="任务状态" prop="taskStatus" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ taskStatusMap(scope.row.taskStatus) }}
          </template>
        </el-table-column>
        <el-table-column label="排查结果" prop="troubleshootingResult" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ result(scope.row.troubleshootingResult) }}
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- <el-pagination
      background
      @size-change="searchList"
      @current-change="findList"
      :current-page.sync="pageNo"
      :page-size.sync="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="total"
      class="float-right mt-20px ml-10px mb-2px"
    ></el-pagination> -->
    <MultiplePersonSelect
      ref="personSelect"
      v-model="person"
      @change="changePerson"
      :isShowUerInput="false"
    >
      <template></template>
    </MultiplePersonSelect>
  </div>
</template>

<script>
import utils from '@/components/safety/enumField/utils'
import { HiddenDangerInvestigationPlanApi } from '@wiz-api/double-prevention-management'
import MultiplePersonSelect from '@/components/safety/PersonSelect/MultiplePersonSelect'
import dayjs from 'dayjs'

const hiddenDangerInvestigationPlanApi = new HiddenDangerInvestigationPlanApi()

export default {
  name: 'check-list-base-table',
  components: {
    MultiplePersonSelect,
  },
  props: {
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'create',
          visible: true,
        }
      },
    },
    planId: {
      default: '',
    },
  },
  filters: {},
  data() {
    return {
      person: '',
      id: '',
      jobTypeList: [],
      jobAreaList: [],
      controlHierarchyList: [],
      // 作业活动清单
      tableData: [],
      tableLoading: false,
      searchData: {
        keywords: '',
        organizationLevel: null,
      },
      total: 0,
      pageNo: 1,
      pageSize: 999,
      selectionData: [],
      taskStatusList: [],
      levelList: [],
    }
  },
  created() {
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.ControlHierarchy',
        'DoublePreventionManagement.DataCategory.TaskStatus',
      ],
      ['controlHierarchyList', 'taskStatusList'],
      this
    )
    this.searchList()
  },
  computed: {
    tableHeight() {
      return '400px'
    },
    result() {
      return (val) => {
        if (val === 1 || val === '1') {
          return '发现隐患'
        }
        if (val === 0 || val === '0') {
          return '正常'
        }
        return val
      }
    },
    taskStatusMap() {
      return (val) => {
        return (
          this.taskStatusList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    controlHierarchyListMap() {
      return (val) => {
        return (
          this.controlHierarchyList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
  },
  watch: {
    selectionData(list) {
      this.$emit('sumCount', {
        key: 'baseCount',
        value: list.length,
      })
    },
  },
  methods: {
    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.searchList()
    },
    handleSelection(values) {
      this.selectionData = values.map((item) => {
        return item.checklistId
      })
    },
    getSelectData() {
      let isEmpty = true
      const list = this.selectionData.map((checklistId) => {
        const row = this.tableData.find((item) => {
          return item.checklistId === checklistId
        })
        if (row.creationTime) {
          row.creationTime = dayjs(row.creationTime).format('YYYY-MM-DD HH:mm:ss')
        }
        if (row.deletionTime) {
          row.deletionTime = dayjs(row.deletionTime).format('YYYY-MM-DD HH:mm:ss')
        }
        if (row.lastModificationTime) {
          row.lastModificationTime = dayjs(row.lastModificationTime).format('YYYY-MM-DD HH:mm:ss')
        }
        if (row.lastModificationTime) {
          row.lastModificationTime = dayjs(row.lastModificationTime).format('YYYY-MM-DD HH:mm:ss')
        }
        if (!row.deadlinePersonId) {
          isEmpty = false
        }
        return row
      })
      return isEmpty ? list : isEmpty
    },
    setSelectData(list) {
      list.forEach((item) => {
        const row = this.tableData.find((i) => {
          return i.checklistId === item.checklistId
        })
        this.$refs.table.toggleRowSelection(row)
      })
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    async findList() {
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const operation = this.formProps.editType
      const listsType =
        // eslint-disable-next-line no-nested-ternary
        operation === 'create' ? 0 : operation === 'update' ? 1 : operation === 'read' ? 2 : 3
      const data = {
        listsType,
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      if (operation !== 'create') {
        data.planId = this.planId
      }
      const [err, res] = await hiddenDangerInvestigationPlanApi.planBasicManagementPagedListQuery(
        data
      )
      if (!err) {
        this.tableData = res.items.map((item) => {
          if (item.deadlinePersonId === '00000000-0000-0000-0000-000000000000') {
            item.deadlinePersonId = ''
          }
          return item
        })
        this.$nextTick(() => {
          this.tableData.forEach((item) => {
            // 设置勾选
            if (item.alreadyExists) {
              this.$refs.table.toggleRowSelection(item)
            }
          })
        })
        this.total = res.totalCount
        this.loading = false
      }
    },
    refreshList() {
      this.findList()
    },
    // 批量修改人员
    changePerson(id) {
      this.tableData.forEach((item) => {
        if (this.selectionData && this.selectionData.length > 0) {
          if (this.selectionData.includes(item.checklistId)) {
            item.deadlinePersonId = id
          }
        } else {
          item.deadlinePersonId = id
        }
      })
    },
    // 列表操作-事件
    handleEvent(row = null, operation) {
      if (['updataAll'].includes(operation)) {
        if (!this.selectionData || this.selectionData.length === 0) {
          this.$message({
            showClose: true,
            message: '请勾选风险点',
            type: 'warning',
          })
          return
        }
      }
      switch (operation) {
        // 批量人
        case 'updataAll':
          this.$nextTick(() => {
            this.$refs.personSelect.showDialog = true
          })
          break
        case 'delete':
          this.$confirm('是否删除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const [err, res] = await xxx.xxx(row.id)
              if (!err) {
                this.$message.success('删除成功')
                this.findList()
              }
            })
            .catch(() => {})
          break
        case 'create':
          this.initDialog(row, operation)
          break
        case 'read':
          this.initDialog(row, operation)
          break
        case 'update':
          this.initDialog(row, operation)
          break
        case 'reject':
          this.taskId = row.id
          this.showDialog = true
          break
        default:
          break
      }
    },
    // 弹窗初始化操作
    initDialog(row, operation) {
      // 没有新增获取数据
      this.id = row && row.id ? row.id : ''
      this.formProps.editType = operation
      this.formProps.title = `${
        // eslint-disable-next-line no-nested-ternary
        operation === 'create' ? '新增' : operation === 'update' ? '编辑' : '查看'
      }基础排查清单`
      this.formProps.visible = true
    },
  },
}
</script>

<style></style>
